module.exports = __webpack_public_path__ + "img/google_drive_logo.4091b61e.png";